import script from "./TimelineClosedCaptionsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./TimelineClosedCaptionsSection.vue?vue&type=script&setup=true&lang=js"

import "./TimelineClosedCaptionsSection.vue?vue&type=style&index=0&id=23e9061f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23e9061f"]])

export default __exports__